import { Chip, Stack, Box } from '@mui/material';
import { FC, useState } from 'react';
import { useDrawerContext } from '../../../../../drawer/DrawerContext';
import { useIntl } from 'react-intl';
import { WidgetCell, WidgetProps } from '../WidgetCell';
import { PersonaAvatarSmall } from '../../../../../persona/PersonaAvatar';
import slugify from 'slugify';
import { widgetDefinitions } from '../widgetDefinitions';

export const PersonasCell: FC<WidgetProps> = ({ widget: { personas }, activityId, activityName }) => {
	const intl = useIntl();
	const [isEditMode, setIsEditMode] = useState(false);
	const { setDrawerWithoutPrevParams } = useDrawerContext();

	return (
		<WidgetCell
			editMode={isEditMode}
			showEditOnHover
			data-activity-widget-name={slugify(activityName, { lower: true })}
			data-activity-widget-type={widgetDefinitions.personas.type}
			tooltipText={intl.formatMessage({ id: 'journey.detail.widget.edit' })}
			handleEditAction={() => {
				setDrawerWithoutPrevParams('editPersonas', { activityId }, () => setIsEditMode(false));
				setIsEditMode(true);
			}}
		>
			<Stack
				display={'flex'}
				justifyContent={'flex-start'}
				height={'100%'}
				alignItems={'flex-start'}
				flexDirection={'row'}
				flexWrap={'wrap'}
				gap={1}
			>
				{personas.length === 0
					? null
					: personas.map((persona) => (
							<Chip
								variant={'outlined'}
								size={'medium'}
								key={persona.id}
								avatar={
									<Box>
										<PersonaAvatarSmall persona={persona} />
									</Box>
								}
								label={persona.name}
								sx={{ bgcolor: (theme) => theme.palette.grey[50] }}
								data-persona={slugify(persona.name, { lower: true })}
							/>
						))}
			</Stack>
		</WidgetCell>
	);
};
